import { toast } from '@mx/vix';
import { delay, normalizeError } from '@mx/pay-common';
import signHelper from '@mx/payment-sign-sdk';
import {
  bridge,
  env,
  getStorage,
  guideSign,
  monitor,
  PAY_TOKEN,
  removeStorage,
  SignState,
  CreditType,
  ToastType,
  metricPoints,
  SignStatusType,
} from '@/common';
import { showErrorModal } from './errorModal';
import { fetchSignDefer } from './signDefer';
import { lx } from '@/analytic';
import { bids, cids } from '@/analytic/lx-constants';
import { cancelDefer, deferIndependenceSignSuccess, deferIndependenceSignFail } from './callbackNativeRouter';
import { wxScorePaySign } from './wxScorePaySign';
import { storeInstance } from '@/store';
import { showPayDelaySignResultPage } from './showResultPage';

const store = storeInstance();
function appear() {
  bridge.subscribe({
    action: 'appear',
    handle: () => {
      getStorage(PAY_TOKEN)
        .then((value: any) => {
          env.setValidateToken(value);
          fetchSignDefer();
        })
        .catch((error: any) => {
          monitor.captureInfo({
            name: '[storage]获取 payToken 失败',
            msg: { error: normalizeError(error) },
          });
          // 失败时需要隐藏 fetchGuideSign 函数设置的 toast，否则用户无法继续点击按钮
          toast.hide();
          // 自动开通流程不验证直接返回，需要关闭透明的webview
          if (env.hideHalfPage) {
            cancelDefer();
          }
        })
        .finally(() => {
          removeStorage(PAY_TOKEN);
        });
      bridge.unsubscribe({
        action: 'appear',
      });
    },
  });
}

export function fetchGuideSign() {
  toast.show('loading', '', {
    delay: 0,
  });

  lx.mc(bids.signPayBtn, {}, { cid: cids.index });

  // 签约支付请求参数
  const guideSignParams: GuideSignParamsType = {
    scorePlanId: env.coreBusinessParams.scorePlanId,
    creditType: env.coreBusinessParams.creditType,
    iphPayMerchantNo: env.iphPayMerchantNo,
    openType: env.openType,
    source: env.source,
  };
  env.setGuideSignParams(guideSignParams);

  guideSign(guideSignParams)
    .then((res) => {
      env.setGuideSignResponseData(res);
      // 目前只支持独立验证流程，其他流程抛错上报
      if (res.state === SignState.verifyPassword) {
        appear();
        if (!res.jumpLink) {
          monitor.captureAjaxErrorMessage('[api]后端未下发验证密码地址', { res });
        }
        bridge.openPage(res.jumpLink ?? '');
      } else if (res.state === SignState.noNeedVerify) {
        fetchSignDefer();
      } else {
        throw new Error('state 暂不支持');
      }
    })
    .catch((error) => {
      toast.hide();
      showErrorModal({ resultData: error });
      monitor.captureAjaxErrorMessage('[api]guideSign引导接口请求失败', { error: normalizeError(error) });
    });
}
export function payDelayIndependenceSign() {
  if (env.creditType === CreditType.WeiXin) {
    wxScorePaySign();
  } else if (env.creditType === CreditType.PayDelay) {
    monitor.reportMetric(metricPoints.signedStatus, { signStatus: SignStatusType.Start });
    const successCallBack = () => {
      monitor.reportMetric(metricPoints.signedStatus, { signStatus: SignStatusType.Success });
      toast.hide();
      const apiFailCallBack = () => {
        store.commit({
          type: 'paydelaycashier/setToast',
          show: true,
          toastType: ToastType.Text,
          toastText: '美团先用后付开通成功',
        });
        // eslint-disable-next-line promise/catch-or-return
        delay(2000).then(() => {
          store.commit({ type: 'paydelaycashier/setToast', show: false });
          deferIndependenceSignSuccess();
        });
      };
      // 展示结果页
      showPayDelaySignResultPage(apiFailCallBack);
    };
    const failCallBack = () => {
      monitor.reportMetric(metricPoints.signedStatus, { signStatus: SignStatusType.Fail });
      toast.hide();
      store.commit({
        type: 'paydelaycashier/setToast',
        show: true,
        toastType: ToastType.Text,
        toastText: '签约结果失败/未查到，请稍后再试',
      });
      // eslint-disable-next-line promise/catch-or-return
      delay(2000).then(() => {
        store.commit({ type: 'paydelaycashier/setToast', show: false });
        deferIndependenceSignFail();
      });
    };
    toast.show('loading', '', {
      delay: 0,
    });
    const loadingHide = () => {
      toast.hide();
    };

    const signHelperParams = {
      source: 'pay_delay_sign_halfpage',
      scorePlanId: env.coreBusinessParams.scorePlanId,
      utmSource: env.utmSource,
      openType: env.openType,
      successCallBack, // 签约成功回调函数
      failCallBack, // 签约失败回调函数
      loadingHide, // 隐藏loading
    };
    signHelper.init({ ...signHelperParams });
    signHelper.fetchQualifyDispatcher();
  }
}
